import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from 'd3';

import ScatterPlotGrid from "./ScatterPlotGrid";
import './ScatterPlot.css';
import HoverOver from "../HoverOver";

class ScatterPlot extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 300,
      height: 300
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    this.setState({width: width, height: Math.min(width, 500)});
  }

  render() {
    return (
      <div ref="wrapper" className="ScatterPlot" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <ScatterPlotGrid
          width={this.state.width}
          height={this.state.height}
          titleX={this.props.titleX}
          titleY={this.props.titleY}
          dimX={this.props.dimX}
          dimY={this.props.dimY}
          dimId={this.props.dimId}
          data={this.props.data}
          onHoverOver={(fips, hover) => {
            this.setState({hover});
            d3.selectAll("#FIPS_" + fips).attr("class", "hover_over");
          }}
          onHoverOut={fips => {
            this.setState({hover: null})
            d3.selectAll("#FIPS_" + fips).attr("class", "hover_out");
          }}
        />
        <HoverOver data={this.state.hover} margin={28}/>
      </div>
    );
  }
}

ScatterPlot.propTypes = {
  titleX: PropTypes.string,
  titleY: PropTypes.string,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  dimId: PropTypes.string,
  data: PropTypes.array
};

export default ScatterPlot;


// WEBPACK FOOTER //
// ./src/charts/ScatterPlot/index.js